module.exports = __webpack_public_path__ + "static/img/logo-s.28037ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-s.png
// module id = 123
// module chunks = 1